const state = {
 add_modal: false,
 view_modal: false,
 edit_modal: false,
 
 id: null,
 type: null,
 company_name: null,
 company_id: null,
 
 reload_addresses: false,
 
 current_address_id: null,
 current_row_id: null
};

const actions = {};

const mutations = {
 SHOW_VIEW_ADDRESS_MODAL(state, payload) {
  state.add_modal = false;
  state.view_modal = true;
  state.edit_modal = false;
  state.id = payload.id;
  state.type = payload.type;
  state.company_name = payload.company_name;
  state.company_id = payload.company_id;
 },
 SHOW_ADD_ADDRESS_MODAL(state, payload) {
  state.add_modal = true;
  state.view_modal = false;
  state.edit_modal = false;
  state.id = payload.id;
  state.type = payload.type;
  state.company_name = payload.company_name;
  state.company_id = payload.company_id;
 },
 SHOW_EDIT_ADDRESS_MODAL(state, payload) {
  state.add_modal = false;
  state.view_modal = false;
  state.edit_modal = true;
  state.id = payload.id;
  state.type = payload.type;
  state.company_name = payload.company_name;
  state.company_id = payload.company_id;
 },
 HIDE_ADDRESS_MODALS(state) {
  state.add_modal = false;
  state.view_modal = false;
  state.edit_modal = false;
  state.id = null;
  state.type = null;
  state.company_name = null;
  state.company_id = null;
 },
 RELOAD_ADDRESSES(state, payload) {
  state.reload_addresses = payload.action;
 },
 SET_ADDRESS_ROW(state, row_id) {
  state.current_row_id = row_id;
 }
};

export default {
 state,
 actions,
 mutations
}
